<template>
  <div class="content">
    <!-- 搜索列表 -->
    <div class="block block-form">
      <div class="block-title">推广订单列表</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.orderId" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="销售类型">
          <el-select v-model="searchForm.dyMediaType" placeholder="请选择销售类型">
            <el-option
              v-for="item in dyMediaTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="searchForm.orderStatus" placeholder="请选择订单状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <!-- 主小程序显示dyProxyNickname -->
        <el-form-item label="代理昵称" v-if="isDyAppOwner">
          <el-input
            v-model="searchForm.dyProxyNickname"
            placeholder="代理昵称"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="达人昵称/达人ID">
          <el-input
            v-model="searchForm.reference"
            placeholder="达人昵称/达人ID"
            maxlength="20"
          />
        </el-form-item>
        <el-form-item label="给达人结佣状态">
          <el-select
            v-model="searchForm.dyDarenSettleStatus"
            placeholder="请选择给达人结佣状态"
          >
            <el-option
              v-for="item in payStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否优惠券下单">
          <el-select
            v-model="searchForm.couponTypeId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <!-- 主小程序平台结佣状态ownerSettleStatus 给代理结佣状态dyProxySettleStatus  否则平台结佣状态 dyProxySettleStatus-->
        <template v-if="isDyAppOwner">
          <el-form-item label="平台结佣状态">
            <el-select
              v-model="searchForm.ownerSettleStatus"
              placeholder="请选择平台结佣状态"
            >
              <el-option
                v-for="item in payStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="给代理结佣状态">
            <el-select
              v-model="searchForm.dyProxySettleStatus"
              placeholder="请选择给代理结佣状态"
            >
              <el-option
                v-for="item in payStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="平台结佣状态">
            <el-select
              v-model="searchForm.dyProxySettleStatus"
              placeholder="请选择平台结佣状态"
            >
              <el-option
                v-for="item in payStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </template>

        <el-form-item label="下单时间">
          <el-date-picker
            v-model="orderCreateTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="changeOrderCreateTime"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结算时间">
          <el-date-picker
            v-model="settleTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            @change="changeSettleTime"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="给达人结佣时间">
          <el-date-picker
            v-model="searchForm.masterTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="平台结佣时间" v-if="!isDyAppOwner">
          <el-date-picker
            v-model="searchForm.platformTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>

        <!-- 主小程序显示给代理结佣时间-->
        <el-form-item label="给代理结佣时间" v-if="isDyAppOwner">
          <el-date-picker
            v-model="searchForm.agencyTime"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button :loading="exportLoading" @click="onFormExport">导出数据</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 统计数据 -->
    <num-list :totalAllData="totalAllData" />
    <!--   直播表格-->
    <div class="block block-top">
      <el-table
        v-loading="tableLoading"
        :data="tableList.list"
        border
        highlight-current-row
        style="width: 100%"
        header-row-class-name="header"
      >
        <el-table-column label="订单号" width="240" prop="orderId">
          <template slot-scope="{ row }">
            <div class="order">
              <div calss="order-uuId">{{ row.orderId }}</div>
              <div :class="['order-media', setMediaColor(row.dyMediaType)]">
                {{ row.dyMediaTypeStr }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="120" prop="orderStatusStr" />
        <el-table-column width="110" label="市场价（元）" prop="initPriceStr" />
        <el-table-column width="80" label="优惠券金额（元）" prop="cheaperPriceBd"/>
        <el-table-column width="80" label="优惠券类型" prop="couponType"/>
        <el-table-column width="80" label="优惠券承担者" prop="couponHolder"/>
        <el-table-column width="120" label="支付金额（元）" prop="payAmountStr" />
        <!-- <el-table-column width="80" label="退款金额" prop="refundPriceStr"/> -->
        <el-table-column width="120" label="退款金额（元）">
          <template #default="{ row }">
            <div v-if="row.orderStatus == 10">{{ row.payAmountStr }}</div>
          </template>
        </el-table-column>
        <el-table-column width="160" label="销售溢价">
          <template #default="{ row }">
            <div>溢价比例：{{ row.dyDarenSellPremiumRateStr }}</div>
            <div>溢价金额：{{ row.dyDarenSellPremiumStr }}元</div>
          </template>
        </el-table-column>
        <el-table-column width="140">
          <template slot="header">
            <span>我的预估佣金</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <i class="el-icon-question"></i>
              <div slot="content">
                <p>未扣除达人佣金</p>
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <!-- 主小程序显示appCommissionStr 否则显示dyProxyCommissionStr -->
            <div v-if="isDyAppOwner">
              {{ row.appCommissionStr }}
            </div>
            <div v-else>
              {{ row.dyProxyCommissionStr }}
            </div>
          </template>
        </el-table-column>
        <!-- 主小程序显示proxyNickname,dyProxyCommissionStr -->
        <template v-if="isDyAppOwner">
          <el-table-column width="120" label="所属分销代理" prop="proxyNickname" />
          <el-table-column
            width="180"
            label="分销代理预估佣金"
            prop="dyProxyCommissionStr"
          />
        </template>

        <el-table-column width="120" label="达人预估佣金" prop="dyDarenCommissionStr" />
        <el-table-column label="达人" prop="reference" width="140">
          <template slot-scope="{ row }">
            <div>{{ row.referenceNickname }}</div>
            <div class="text">达人ID：{{ row.reference }}</div>
          </template>
        </el-table-column>
        <el-table-column width="140" label="下单用户" prop="fans">
          <template slot-scope="{ row }">
            <div>{{ row.fansNickname }}</div>
            <div class="text">用户ID：{{ row.fansId }}</div>
          </template>
        </el-table-column>
        <el-table-column width="180">
          <template #header>
            <div>
              结佣状态
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">
                  <div>平台结佣：平台给代理结佣的状态。</div>
                  <div>给达人结佣：代理给达人结佣的状态。</div>
                </div>
                <el-icon class="el-icon-question" />
              </el-tooltip>
            </div>
          </template>
          <template #default="{ row }">
            <!-- 主小程序平台结佣状态ownerSettleStatus 给代理结佣状态dyProxySettleStatus  否则平台结佣状态 dyProxySettleStatus-->

            <div>
              给达人结佣：<span
                :style="{ color: row.dyDarenSettleStatus === 0 ? 'red' : 'green' }"
                >{{ row.dyDarenSettleStatusStr }}</span
              >
            </div>
            <template v-if="isDyAppOwner">
              <div>
                平台结佣：<span
                  :style="{ color: row.ownerSettleStatus === 0 ? 'red' : 'green' }"
                  >{{ row.ownerSettleStatusStr }}</span
                >
              </div>
              <div>
                给代理结佣：<span
                  :style="{ color: row.dyProxySettleStatus === 0 ? 'red' : 'green' }"
                  >{{ row.dyProxySettleStatusStr }}</span
                >
              </div>
            </template>
            <template v-else>
              <div>
                平台结佣：<span
                  :style="{ color: row.dyProxySettleStatus === 0 ? 'red' : 'green' }"
                  >{{ row.dyProxySettleStatusStr }}</span
                >
              </div>
            </template>
          </template>
        </el-table-column>

        <el-table-column width="180" label="时间" prop="createTimeStr">
          <template slot-scope="{ row }">
            <div>
              下单时间：
              <div>{{ row.orderCreateTimeStr }}</div>
            </div>
            <div>
              结算时间：
              <div>{{ row.settleTimeStr }}</div>
            </div>

            <div>
              给达人结佣时间：
              <div>{{ row.dyDarenSettleTime }}</div>
            </div>
            <!-- 主小程序平台结佣时间settleTimeStr 给代理结佣时间dyProxySettleTime  否则平台结佣时间 dyProxySettleTime-->
            <template v-if="isDyAppOwner">
              给代理结佣：
              <div>{{ row.dyProxySettleTime }}</div>
            </template>
            <template v-else>
              <div>
                平台结佣时间：
                <div>{{ row.dyProxySettleTime }}</div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="影片" width="100">
          <template slot-scope="{ row }">
            <div>{{ row.orderCinemaInfo.movieName }}</div>
            <div class="color-red">x{{ row.orderNum }}</div>
          </template>
          >
        </el-table-column>
        <el-table-column label="影院" prop="cinemaName" width="140">
          <template slot-scope="{ row }">
            <div>{{ row.orderCinemaInfo.cinemaName }}</div>
            <div class="color-gray">{{ row.orderCinemaInfo.hallName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订单详情" align="center" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" @click="check(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--    分页-->
      <el-pagination
        v-if="tableList.total > 0"
        class="table-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableList.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="影片详情"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <span class="flex">
        <div class="dialog">
          <div class="dialog-flex">
            <div class="dialog-title">影片图片：</div>
            <div class="image">
              <el-image
                class="img"
                :preview-src-list="Array(dialogData.orderCinemaInfo.moviePic)"
                :src="dialogData.orderCinemaInfo.moviePic"
                fit="cover"
                @click="reviewImage(dialogData.orderCinemaInfo.moviePic)"
              ></el-image>
              <img class="icon" src="@/assets/img/pop_icon_magnify.png" alt="" />
            </div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">影片名称：</div>
            <div class="dialog-text">
              {{ dialogData.orderCinemaInfo.movieName }}
            </div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">张数：</div>
            <div class="dialog-text">{{ dialogData.orderNum }}</div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">市场价：</div>
            <div class="dialog-text">
              {{
                dialogData.initPrice ? dialogData.initPrice / 100 : dialogData.initPrice
              }}/张
            </div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">购票座位：</div>
            <div class="dialog-text">{{ dialogData.orderCinemaInfo.seat }}</div>
          </div>
          <div class="dialog-flex" v-if="dialogData.orderTicketInfo.seat != null">
            <div class="dialog-title">实际座位：</div>
            <div class="dialog-text">{{ dialogData.orderTicketInfo.seat }}</div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">放映时间：</div>
            <div class="dialog-text">
              {{ dialogData.orderCinemaInfo.showTimeStr }}
            </div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">城市：</div>
            <div class="dialog-text">{{ dialogData.orderCinemaInfo.city }}</div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">影院：</div>
            <div class="dialog-text">
              {{ dialogData.orderCinemaInfo.cinemaName }}
            </div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">厅：</div>
            <div class="dialog-text">
              {{ dialogData.orderCinemaInfo.hallName }}
            </div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">地址：</div>
            <div class="dialog-text">
              {{ dialogData.orderCinemaInfo.cinemaAddress }}
            </div>
          </div>
        </div>
        <div class="dialog" style="margin-left: 41px">
          <div class="dialog-flex">
            <div class="dialog-title">订单号：</div>
            <div class="dialog-text">{{ dialogData.orderId }}</div>
          </div>
          <div class="dialog-flex">
            <div class="dialog-title">下单时间：</div>
            <div class="dialog-text">
              {{ dialogData.orderCinemaInfo.createTime }}
            </div>
          </div>
          <div class="dialog-flex" v-if="dialogData.orderStatus >= 4">
            <div class="dialog-title">取票码：</div>
            <div
              class="dialog-text"
              v-for="(item, index) in dialogData.orderTicketCodeList"
              :key="index"
            >
              {{ item }}
            </div>
          </div>
          <div class="dialog-flex" v-if="dialogData.orderStatus >= 4">
            <div class="dialog-title" style="width: 90px">取票码截图：</div>
            <div
              class="image"
              v-for="(item, index) in dialogData.orderTicketImageList"
              :key="index"
            >
              <el-image
                class="img"
                :src="item"
                :preview-src-list="Array(item)"
              ></el-image>
              <img class="icon" src="@/assets/img/pop_icon_magnify.png" alt="" />
            </div>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import douYin from "@/javaApi/douyin";
import debounce from "@/utils/debounce.js";
const DouYinModel = new douYin();
import numList from "./NumList";
import { formatDate } from "@/utils/tool";

const searchParams = {
  ownerSettleStatus: "", // 平台结佣状态
  dyProxyNickname: "", // 代理昵称
  dyMediaType: "", // 销售类型
  orderCreateStartTime: "",
  orderCreateEndTime: "",
  settleEndTime: "", // 结算结算时间
  settleStartTime: "", // 结算开始时间
  orderStatus: "",
  orderUUID: "",
  reference: "", // 达人ID
  dyProxySettleStatus: "", // 平台结佣状态
  dyDarenSettleStatus: "", // 达人结佣状态
  platformTime: [], // 平台结佣时间
  masterTime: [], // 达人结佣时间
  agencyTime: [], // 代理结佣时间
  pageSize: 10,
  pageNo: 1,
  couponTypeId: "全部",// 是否优惠券下单
};
export default {
  name: "index",
  components: {
    numList,
  },
  data() {
    return {
      exportLoading: false, // 导出loading
      totalAllData: {}, // 统计数据
      searchForm: Object.assign({}, searchParams),
      payStatusList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "未结佣",
        },
        {
          value: 1,
          label: "已结佣",
        },
      ],
      optionsType: [
        {
          label: '全部',
          value: ""
        },
        {
          label: '是',
          value: "1"
        }, {
          label: '否',
          value: "0"
        }
      ],
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "待支付",
        },
        {
          value: "2",
          label: "受理中",
        },
        {
          value: "3",
          label: "待出票",
        },
        {
          value: "4",
          label: "已出票",
        },
        {
          value: "5",
          label: "已结算",
        },
        {
          value: "10",
          label: "订单关闭",
        },
      ],
      settleTime: [], // 结算日期
      orderCreateTime: [], // 下单日期
      tableList: {
        list: [],
        total: 0,
      },
      currentPage: 1,
      info: {},
      dialogVisible: false,
      dialogData: {
        orderCinemaInfo: {
          moviePic: "",
          movieName: "",
          seat: "",
          showTimeStr: "",
          city: "",
          cinemaName: "",
          hallName: "",
          cinemaAddress: "",
          createTime: "",
        },
        orderTicketInfo: {
          seat: "",
        },
        orderNum: "",
        orderUUID: "",
      }, //弹窗数据
      srcList: [], //图片预览
      // 销售类型
      dyMediaTypeList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 1,
          label: "直播",
        },
        {
          value: 2,
          label: "短视频",
        },
        {
          value: 0,
          label: "其他",
        },
      ],
      tableLoading: false, // 表格loading
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    // 默认时间选择框下单时间为7天
    this.orderCreateTime = [
      new Date(new Date().getTime() - 6 * 24 * 60 * 60 * 1000),
      new Date(),
    ];
    // orderCreateTime日期格式转换为年月日
    this.orderCreateTime = this.orderCreateTime.map((item) => {
      return this.formatDateHandel(item);
    });
    this.searchForm.orderCreateStartTime = this.orderCreateTime[0];
    this.searchForm.orderCreateEndTime = this.orderCreateTime[1];
    this.freshTable();
    this.getOrderListNum();
  },
  computed: {
    ...mapGetters(["isDyAppOwner"]),
  },
  methods: {
    // 设置订单类型
    setMediaColor(dyMediaType) {
      const obj = {
        0: "order-media__other",
        1: "order-media__live",
        2: "order-media__short",
      };
      return obj[dyMediaType];
    },
    // 修改下单时间
    changeOrderCreateTime(arr) {
      if (arr && arr.length) {
        this.searchForm.orderCreateStartTime = arr[0];
        this.searchForm.orderCreateEndTime = arr[1];
      } else {
        this.searchForm.orderCreateStartTime = "";
        this.searchForm.orderCreateEndTime = "";
      }
    },
    // 修改结算时间
    changeSettleTime(arr) {
      if (arr && arr.length) {
        this.searchForm.settleStartTime = arr[0];
        this.searchForm.settleEndTime = arr[1];
      } else {
        this.searchForm.settleStartTime = "";
        this.searchForm.settleEndTime = "";
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val;
      this.freshTable();
    },
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.freshTable();
    },
    // 设置参数
    setParams() {
      // miniAppType:'5'快手
      const params = { ...this.searchForm, miniAppType: 5 };
      console.log(this.isDyAppOwner, "this.isDyAppOwner");
      // 如果是主小程序
      if (this.isDyAppOwner) {
        // 平台结佣时间
        // params.settleStartTime = params.platformTime && params.platformTime.length ? params.platformTime[0] : ""
        // params.settleEndTime = params.platformTime && params.platformTime.length ? params.platformTime[1] : ''
        // 代理结佣时间
        params.dyProxySettleStartTime =
          params.agencyTime && params.agencyTime.length ? params.agencyTime[0] : "";
        params.dyProxySettleEndTime =
          params.agencyTime && params.agencyTime.length ? params.agencyTime[1] : "";
      } else {
        // 平台结佣时间
        params.dyProxySettleStartTime =
          params.platformTime && params.platformTime.length ? params.platformTime[0] : "";
        params.dyProxySettleEndTime =
          params.platformTime && params.platformTime.length ? params.platformTime[1] : "";
      }
      // 给达人结佣时间
      params.dyDarenSettleStartTime =
        params.masterTime && params.masterTime.length ? params.masterTime[0] : "";
      params.dyDarenSettleEndTime =
        params.masterTime && params.masterTime.length ? params.masterTime[1] : "";
      delete params.platformTime;
      delete params.masterTime;
      delete params.agencyTime;
      return params;
    },
    freshTable() {
      this.tableLoading = true;
      let params = this.setParams();

      DouYinModel.liveOrderList(params).then((res) => {
        if (res.data.code === 200) {
          this.info = res.data.data;
          this.tableList.list = res.data.data.list.map((item)=>{
            return {
              ...item,
              cheaperPriceBd: item.cheaperPriceBd ? item.cheaperPriceBd : "-",
              couponType: item.couponType ? item.couponType : "-",
              couponHolder: item.couponHolder ? item.couponHolder : "-",
            };
          });
          this.tableList.total = res.data.data.total;
        }
        this.tableLoading = false;
      });
    },
    async getOrderListNum() {
      let params = this.setParams();
      const res = await DouYinModel.getOrderListNum(params);
      if (res.data.code === 200) {
        this.totalAllData = res.data.data;
      }
    },
    onFormSearch() {
      debounce(
        () => {
          this.searchForm.pageNo = 1;
          this.freshTable();
          this.getOrderListNum();
        },
        500,
        true
      );
    },
    // 重置
    onFormReset() {
      debounce(
        () => {
          this.settleTime = [];
          this.orderCreateTime = [];
          this.searchForm = Object.assign({}, searchParams);
          this.freshTable();
          this.getOrderListNum();
        },
        500,
        true
      );
    },
    check(row) {
      this.dialogData = row;
      // 循环处理取票码和取票图片格式
      let codeList = this.dialogData.orderTicketCode;
      let codeArr = [];
      let imageArr = [];
      for (let index in codeList) {
        //type为1的数组是取票码，2是图片
        if (codeList[index].type === 1) {
          codeArr.push(codeList[index].code);
        } else {
          imageArr.push(codeList[index].url);
        }
      }

      this.dialogData.orderTicketCodeList = codeArr;
      this.dialogData.orderTicketImageList = imageArr;
      this.dialogVisible = true;
    },
    timestampToTime(timestamp) {
      var date = new Date(timestamp * 1000);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-";
      var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    reviewImage(url) {
      this.srcList = [];
      this.srcList.push(url);
    },
    onFormExport() {
      this.exportLoading = true;
      let params = this.setParams();
      console.log(params, "导出params");
      DouYinModel.liveOrderExportData(params)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          console.log("blob", blob);
          let url = window.URL.createObjectURL(blob);
          console.log("url", url);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.href = window.URL.createObjectURL(blob);
          a.download = "推广订单列表" + formatDate(new Date()) + ".xls";
          a.click();
          window.URL.revokeObjectURL(url);
          this.exportLoading = false;
          this.$message({
            message: "导出成功",
            type: "success",
          });
        })
        .catch(() => {
          this.exportLoading = false;
        });
    },
    formatDateHandel(date) {
      var year = date.getYear() + 1900; // getYear返回的是从1900年开始算起的年份，需加上1900
      var month = date.getMonth() + 1; // getMonth返回的是0-11，需要加1
      var day = date.getDate();

      // 格式化为yyyy-mm-dd格式
      var formattedDate =
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (day < 10 ? "0" + day : day);
      return formattedDate;
    },
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
}

.dialog {
  .dialog-flex {
    display: flex;
    margin-top: 10px;

    .dialog-title {
      min-width: 70px;
      width: 70px;
      text-align: right;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 20px;
    }

    .dialog-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #222222;
      line-height: 20px;
    }
  }
}

.input {
  width: 160px;
}

.text {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 17px;
}

.image {
  width: 60px;
  height: 82px;
  border-radius: 8px;
  margin-right: 10px;
  position: relative;
  display: flex;

  .img {
    width: 60px;
    height: 82px;
    border-radius: 8px;
  }
}

.icon {
  position: absolute;
  bottom: 0;
  right: 0;
}

.order {
  display: flex;

  &-media {
    margin-left: 10px;
    text-align: center;
    min-width: 50px;
    height: 25px;
    line-height: 25px;

    &__other {
      background: #f1fbf2;
      color: #51c456;
    }

    &__live {
      background: #f0f8ff;
      color: #3d9efc;
    }

    &__short {
      background: #fff8ec;
      color: #ff8622;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/liveOrderList/index.vue